import { apiRequest } from './client';

export type DashboardLatestUser = {
  _id: string;
  name?: string | null;
  email: string;
  phone?: string | null;
  profilePicture?: string | null;
  createdAt?: string;
};

export type DashboardStats = {
  amountToday: number;
  amountThisWeek: number;
  amountThisMonth: number;
  latestUsers: DashboardLatestUser[];
};

export type DashboardGraphData = {
  year: number;
  usersThisYear: number[];
  previousYear: number;
  usersPreviousYear: number[];
};

export const dashboardApi = {
  getStats: () =>
    apiRequest<DashboardStats>('/admin/dashboard/get-stats', {
      method: 'GET',
      auth: true,
    }),

  getGraphData: (year: number | string) =>
    apiRequest<DashboardGraphData>(`/admin/dashboard/get-graph-data?year=${year}`, {
      method: 'GET',
      auth: true,
    }),
};
